import { render, staticRenderFns } from "./invoice.vue?vue&type=template&id=65228158&"
import script from "./invoice.vue?vue&type=script&lang=js&"
export * from "./invoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65228158')) {
      api.createRecord('65228158', component.options)
    } else {
      api.reload('65228158', component.options)
    }
    module.hot.accept("./invoice.vue?vue&type=template&id=65228158&", function () {
      api.rerender('65228158', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/invoice.vue"
export default component.exports